export default __webpack_public_path__ + "static/media/img-slider-asaph-1.a8ee9897.png";